import BaseSupportTool from './base_support_tool';

const POLL_INTERVAL_MS = 500;
const MAX_POLLS = 60;

// The snippet loads on window load, so the real zE arrives after documentReady.
export const waitForZendesk = async (): Promise<boolean> => {
  for (let i = 0; i < MAX_POLLS; i++) {
    if (window.zE) {
      return true;
    }
    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
  }
  return false;
};

class ZendeskMessaging extends BaseSupportTool {
  name() {
    return 'Zendesk';
  }

  isEnabled() {
    return true;
  }

  isReady() {
    return !!window.zE;
  }

  // ponytail: Messaging has no chat:isChatting API, so a reload does not resume an agent chat.
  // Add a check when Forethought confirms how its handoff targets Messaging.
  isChatting() {
    return false;
  }

  initialize = async () => {
    await waitForZendesk();
  };

  onInitialize = async () => {
    this.supportToolManager.resetLocalStorageTool();

    window.zE?.('messenger:on', 'close', () => {
      this.supportToolManager.goToPrevious();
    });
  };

  // The manager hides this tool at documentReady, before the snippet defines zE.
  hide() {
    if (window.zE) {
      this.messenger('hide');
      return;
    }
    if (this.hidePending) {
      return;
    }
    this.hidePending = true;
    void waitForZendesk().then(() => {
      if (this.hidePending) {
        this.messenger('hide');
      }
    });
  }

  show() {
    this.messenger('show');
  }

  open = () => {
    this.messenger('open');
  };

  private hidePending = false;

  private messenger(command: 'hide' | 'show' | 'open') {
    this.hidePending = false;
    window.zE?.('messenger', command);
  }
}

export default ZendeskMessaging;
